import React, { useEffect, useState } from "react";
import MenuButton from "./MenuButton";
import { CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setroute, settitlename } from "../store/reducers";
import { useDispatch } from "react-redux";

function Submenu({ data, title }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [isLoading, setIsLoading] = useState(true); // Added loading state

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);

    // Simulate API call delay (remove if data is already coming dynamically)
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleroute = (route1) => {
    dispatch(setroute(route1));
    dispatch(settitlename(title));
    navigate("/detail", { state: { route1, title } });
  };

  return (
    <>
      <div className="col-12 d-flex" style={{ height: isLoading ? "100vh" : "auto" }}      >
        <div className="l-sub">
          <div style={{ marginTop: "0.5em" }} className="com-div">
            <div className="d-flex rpf-title com" style={{ justifyContent: "center" }}>
              <div className="d-flex" style={{ alignItems: "center", marginLeft: "0.7em", marginBottom: "2em" }}>
                <Typography style={{ fontSize: "2em" }}>{title}</Typography>
              </div>
            </div>
          </div>

          {/* Loader */}
          {isLoading ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 1000,
              }}
            >
              <CircularProgress style={{ color: "#4A5E00" }} />
            </div>
          ) : data && Object.keys(data).length > 0 ? (
            <>
              {title !== "Equipment" ? (
                <div className="col-12" style={{ padding: "0 1em", marginBottom: "5em" }}>
                  {Object.keys(data).map((key) => (
                    <div key={key}>
                      <Typography
                        style={{
                          fontSize: "1.5em",
                          marginBottom: "1em",
                          marginTop: "1.5em",
                          fontWeight: "500",
                        }}
                      >
                        {key}
                      </Typography>

                      <div className="responsive-grid">
                        {data[key]?.map((item, index) => (
                          <div key={index} className="list-sub" onClick={() => handleroute(item)}>
                            <p className="item-hover">{item}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

              ) : (
                <div className="col-12" style={{ padding: "0 1em", marginBottom: "5em" }}>
                  <div className="responsive-grid">
                    {data.map((item, index) => (
                      <div
                        key={index}
                        className="list-sub "
                      // style={{ borderBottom: '1px solid #8080802e',whiteSpace:'nowrap' }}
                      >
                        <p className="item-hover" onClick={() => handleroute(item)}>
                          {item}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>

              )}
            </>
          ) : (
            <div style={{ textAlign: "center", margin: "2em", height: '100vh' }}>
              <Typography>No data found</Typography>
            </div>
          )}
        </div>

        {!isMobile && (
          <div id="sidemenu" className="sidemenu" style={{ marginLeft: "2em", backgroundColor: "rgba(128, 128, 128, 0.15)" }}>
            <MenuButton />
          </div>
        )}
      </div>
    </>
  );
}

export default Submenu;
